import * as stylex from '@stylexjs/stylex';
export const styles = {
  container: {
    maxWidth: "x1ptgtm5",
    marginInline: "xvueqy4",
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    paddingTop: "xf6mfmo",
    paddingInline: "x1qhpy6z",
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBottom: "x117aka2",
    display: "x78zum5",
    flexDirection: "xdt5ytf",
    alignItems: "x6s0dn4",
    textAlign: "x2b8uid",
    $$css: true
  },
  title: {
    marginTop: "xwg69jb",
    marginBottom: "xhbfen4",
    fontSize: "xngnso2",
    $$css: true
  },
  lead: {
    margin: "x1ghz6dp",
    marginInline: null,
    marginInlineStart: null,
    marginLeft: null,
    marginInlineEnd: null,
    marginRight: null,
    marginBlock: null,
    marginTop: null,
    marginBottom: "x1t84w78",
    lineHeight: "x1evy7pa",
    $$css: true
  }
};